import {Injectable} from "@angular/core";
import {User, StreamProject} from "../interfaces";
import {HttpClient} from "@angular/common/http";
import {Observable, of, throwError} from "rxjs";
 import {switchMap, catchError, tap, map} from 'rxjs/operators';


@Injectable({providedIn: 'root'})
export class SocialAuthService {


 private token = null
   user:any = null
  constructor(private http: HttpClient){
    const potentialToken = localStorage.getItem('social-auth-token')
    
    if(potentialToken !== null){
      this.setToken(potentialToken) 
    }
 
  }

  setToken(token: string){
    this.token = token
  }



  
  login(uloginToken){
 
    return this.http.get(`/api/social_auth/login/${uloginToken}`)
      .pipe(
        map((data:any)=>{
          if(!data.error){
              this.user = {
                name: data.name,
                avatar: data.avatar
              }

              
              localStorage.setItem('social-auth-token', data.token)
              this.setToken(data.token)

              return data
          }
          return false
        }) 
      )
      


  }



  loginByName(chat_id, name){
 
    return this.http.post(`/api/social_auth/login_name/${chat_id}`,{user_name: name})
      .pipe(
        map((data:any)=>{
          if(!data.error){
              this.user = {
                name: data.name,
                avatar: data.avatar
              }

              
              localStorage.setItem('social-auth-token', data.token)
              this.setToken(data.token)

              return data
          }
          return false
        }) 
      )
      


  }



  
  loginEmail(key){
 
    return this.http.get(`/api/social_auth/email/${key}`)
      .pipe(
        tap((data:any)=>{
          if(!data.error){
              this.user = {
                name: data.name,
                avatar: data.avatar
              }
 
 
              localStorage.setItem('social-auth-token', data.token)
              this.setToken(data.token)
 
              return data
          }
          return false
        }) 
      )
      


  }



/*
  login(user:User):Observable<{token: string}>{
   return  this.http.post<{token: string}>( `/api/auth/login`, user)
     .pipe(
       tap(({token})=> {
         localStorage.setItem('social-auth-token', token)
         this.setToken(token)
       }),
       catchError(error=>throwError(error))
     )

  } */
 

  getToken():string{
    return this.token
  }

  isAuthenticated(){
    return !!this.token
  }
  logout(){
    this.setToken(null)
    localStorage.removeItem('social-auth-token')
  }




  postEmail(email:string): Observable<StreamProject>{
  
    return this.http.post<any>(`/api/social_auth/email`, {email})
  }


}
